import type { Dictionary, DictionaryEntry } from '@lens/shared';

export function entryLabel(entry: DictionaryEntry, dict: Dictionary | null): string {
  const values = entry.values as Record<string, unknown>;
  const displayCol = dict ? dict.columns.find((c) => c.id === dict.displayColumnId) : undefined;
  if (displayCol) {
    const v = values[displayCol.slug];
    if (typeof v === 'string' && v) return v;
  }
  const fallback = Object.values(values).find((v) => typeof v === 'string' && v) as string | undefined;
  return fallback ?? entry.id;
}
